/* eslint-disable eqeqeq */
import { Box, Button, Divider, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Encrypt, formatNumber, maskDigits, trimText } from "../../../../../utils";
import AppLoader from "../../../../../components/AppLoader";
import { showMessageBar, getPockytFees, setLastRefId, clearPockytFees } from "../../../../../store/actions";

import { useDispatch, useSelector } from "react-redux";
import { ACTIVITY_DETAIL, EVENTS, MESSAGE_BAR_TYPES, USD } from "../../../../../utils/constants";
// import { useNavigate } from "react-router-dom";
import AppScreenLoader from "../../../../../components/AppScreenLoader";
import * as PropTypes from "prop-types";
import { fiatWithdraw, logEvent } from "../../../../../store/api";
import { useLocation, useNavigate } from "react-router-dom";
import AppToolTip from "../../../../../components/AppTooltip";
import { EVENTS as EVENTSM } from '../../../../../utils/events';
// import { withdrawPayloadApi } from "../../../../../store/api";

export default function PaymentSummary({
  amount,
  bank,
  paymentCurrency = "USD",
  setActive
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const location = useLocation();
  const [waitingText, setWaitingText] = useState("");
  const feestructure = useSelector(({ transfer }) => transfer.pocFees);
  // const onSuccess = (data) => {
  //   setLoading(false);
  //   setWaitingText("");
  //   navigate(`/withdraw/status/${data.id}`);
  // };

  useEffect(() => {
    if (!bank?.accountToken || !amount) {
      //return to country selec
      setActive(2);
      return
    }
    const encryptedReq = Encrypt(
      JSON.stringify({
        currency: paymentCurrency,
        accountToken: bank.accountToken,
        amount: amount,
      })
    );
    const payload = {
      encryptedReq
    }
    dispatch(getPockytFees(payload));

    return () => {
      dispatch(clearPockytFees());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handlePayment = async () => {
    setLoading(true);
    setWaitingText("Initiating Transfer ...")

    try {

      const payload = {
        accountToken: bank.accountToken,
        amount,
        currency: paymentCurrency,
        recordId: feestructure.recordId,
      }
      console.log(payload)
      const data = await fiatWithdraw(payload)
      logEvent({
        current: EVENTS.WITHDRAWAL.CONFIRM_FIAT_TRANSFER,
        activity: ACTIVITY_DETAIL.WITHDRAWAL.CONFIRM_FIAT_TRANSFER,
        meta: {
          data: {
            currency: paymentCurrency,
            method: 'xbd',
            accountToken: bank.accountToken,
            pathname: location.pathname,
            source: ACTIVITY_DETAIL.WITHDRAWAL.CONFIRM_FIAT_TRANSFER
          }
        }
      });
      setLoading(false);
      setWaitingText("");
      dispatch(setLastRefId(data.result.id));
      navigate(`/withdraw/status/${data.result.id}`);
      logEvent({
        current: EVENTSM.BANK_TRANSFER.BANK_TRANSFER_INITIATED,
        activity: EVENTSM.BANK_TRANSFER.BANK_TRANSFER_INITIATED,
        meta: {
          payoutId: data?.result?.id
        }
      });
    } catch (err) {
      setLoading(false);
      setWaitingText("");
      dispatch(showMessageBar(MESSAGE_BAR_TYPES.ERROR, err))
      logEvent({
        current: EVENTSM.BANK_TRANSFER.BANK_TRANSFER_FAILED,
        activity: EVENTSM.BANK_TRANSFER.BANK_TRANSFER_FAILED,
        meta: {
          error: err
        }
      });
    }
  }
  if (!Object.keys(feestructure || {}).length > 0) {
    return <AppScreenLoader />;
  }
  return (
    <Paper
      sx={{
        backgroundColor: "transparent",
        boxShadow: "none",
        paddingTop: 4,
      }}
    >
      <Grid container sx={{ color: "#D6E3F0", margin: 0 }}>
        <Grid item xs={6}>
          <Typography
            fontFamily={"Manrope"}
            fontSize={14}
            textAlign="left"
            fontWeight={400}
            textTransform="capitalize"
            color="#D4D4D8"
          >
            {t("go.bank")}:
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography
            fontFamily={"Manrope"}
            fontSize={14}
            textAlign="right"
            textTransform="capitalize"
            fontWeight={400}
            color="#D4D4D8"
          >
            {maskDigits(bank?.accountNumber)}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography
            fontFamily={"Manrope"}
            fontSize={14}
            fontWeight={400}
            textAlign="left"
            textTransform="capitalize"
            color="#D4D4D8"
          >
            {t("Amount Requested")}:
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography
            fontFamily={"Manrope"}
            fontSize={14}
            fontWeight={400}
            textAlign="right"
            textTransform="capitalize"
            color="#D4D4D8"
          >
            {formatNumber(amount)} USD
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography
            fontFamily={"Manrope"}
            fontSize={14}
            textAlign="left"
            fontWeight={400}
            textTransform="capitalize"
            color="#D4D4D8"
          >
            {t("Currency requested")}:
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography
            fontFamily={"Manrope"}
            fontSize={14}
            textAlign="right"
            textTransform="uppercase"
            fontWeight={400}
            color="#D4D4D8"
          >
            {paymentCurrency}
          </Typography>
        </Grid>

        {feestructure?.feeEnabled && (
          <>
            <Grid item xs={7}>
              <Typography
                fontFamily={"Manrope"}
                fontSize={14}
                textAlign="left"
                fontWeight={400}
                textTransform="capitalize"
                color="#D4D4D8"
              >
                {t("processing-fee")}:
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography
                fontFamily={"Manrope"}
                fontSize={14}
                textAlign="right"
                textTransform="uppercase"
                fontWeight={400}
                color="#D4D4D8"
              >
                {feestructure?.processingFeeFlatUsd
                  ? `${feestructure?.processingFeeFlatUsd} USD`
                  : ""}
                &nbsp;
                {parseFloat(feestructure?.processingFeePercent?.toString()) !=
                  "0"
                  ? `+ ${feestructure?.processingFeePercent}%`
                  : ""}
                {!feestructure?.processingFeeFlatUsd && parseFloat(feestructure?.processingFeePercent?.toString()) == "0" ? "0 USD": ""}
              </Typography>
            </Grid>
          </>
        )}
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid
          item
          xs={6}
          fontSize={14}
          textTransform="capitalize"
          color="#D4D4D8"
        >
          <Typography
            fontFamily={"Manrope"}
            fontSize={14}
            textAlign="left"
            textTransform="capitalize"
            fontWeight={400}
            color="#D4D4D8"
          >
            Amount to be sent:
          </Typography>
        </Grid>
        <Grid
          item
          xs={6}
          textAlign="right"
          fontSize={14}
          textTransform="capitalize"
          color="#D4D4D8"
        >
          <Typography
            fontFamily={"Manrope"}
            fontSize={14}
            textAlign="right"
            textTransform="uppercase"
            fontWeight={400}
            color="#D4D4D8"
          >
            {feestructure?.payoutAmountUsd} USD
          </Typography>
        </Grid>
        {paymentCurrency.toUpperCase() !== USD ? <>
          <Grid item xs={6}>
            <Typography
              fontFamily={"Manrope"}
              fontSize={14}
              textAlign="left"
              textTransform="capitalize"
              fontWeight={400}
              color="#D4D4D8"
            >
              {t("exchangeRate")}:
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography
              fontFamily={"Manrope"}
              fontSize={14}
              textAlign="right"
              textTransform="capitalize"
              fontWeight={400}
              color="#D4D4D8"
            >
              <span>1 USD ~ </span>
              <AppToolTip
                enterTouchDelay={0}
                title={`${feestructure?.rkflRate?.toString()} ${feestructure?.currency}`}
                placement="top" arrow>
                <span>{trimText((feestructure?.rkflRate?.toString() || ''), 6)}</span>
              </AppToolTip>&nbsp;{feestructure?.currency}
            </Typography>
          </Grid></> : <></>}
        <Grid item xs={12}>
          <Divider />
        </Grid>

        <Grid item xs={6}>
          <Typography
            fontFamily={"Manrope"}
            fontSize={14}
            textAlign="left"
            textTransform="capitalize"
            fontWeight={400}
            color="#D4D4D8"
          >
            {t("Amount to be received")}:
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            justifyContent={"flex-end"}
          >
            <Typography
              fontFamily={"Manrope"}
              fontSize={24}
              textAlign="right"
              textTransform="uppercase"
              fontWeight={400}
              color="#D4D4D8"
            >
              {formatNumber(feestructure.payoutAmount || 0)} {(feestructure.currency || '')}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          {waitingText && (
            <Box
              display={"flex"}
              flexDirection="row"
              alignItems={"center"}
              marginTop={1}
              sx={{
                display: "flex",
                flexFlow: "row",
                alignItems: "center",
                marginBottom: 1,
              }}
            >
              <AppLoader
                title={waitingText}
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
                fontSize={14}
              />
            </Box>
          )}
        </Grid>
      </Grid>
      <Button
        variant="contained"
        size="large"
        color="primary"
        sx={{
          color: "#041939",
          marginTop: 2,
          fontSize: 16,
          width: "100%",
          textTransform: "capitalize",
          borderRadius: "8px",
          ":disabled": { backgroundColor: "#0088F5", opacity: 0.4 },
        }}
        disabled={loading || feestructure?.error}
        onClick={handlePayment}
      >
        {t("Confirm")}
      </Button>
    </Paper>
  );
}

PaymentSummary.propTypes = {
  amount: PropTypes.any,
  // currency: PropTypes.string,
  paymentCurrency: PropTypes.string,
  // paymentMethod: PropTypes.object,
  // feestructure: PropTypes.object,
  bank: PropTypes.object,
  setActive: PropTypes.func
  // loading: PropTypes.bool,
};
